<div [formGroup]="partitionFormGroup" class="partition-form">
    <!-- First Row: Partition Name and Length -->
    <div class="partition-form-row">
        <div class="input-group-farm">
            <label for="name{{ index }}"
                >Partition Name:<span class="text-danger-required"
                    >*</span
                ></label
            >
            <input
                id="name{{ index }}"
                formControlName="name"
                class="input-field"
                placeholder="Enter partition name"
                [ngClass]="{
                    'is-invalid': isControlInvalid('name'),
                    'is-valid':
                        !isControlInvalid('name') &&
                        partitionFormGroup.get('name').touched
                }"
            />
            <div
                class="invalid-feedback"
                *ngIf="
                    partitionFormGroup.get('name').invalid &&
                    partitionFormGroup.get('name').touched
                "
            >
                Partition name is required.
            </div>
        </div>

        <div class="input-group-farm">
            <label for="length{{ index }}"
                >Length (m):<span class="text-danger-required">*</span></label
            >
            <input
                id="length{{ index }}"
                formControlName="length"
                type="number"
                min="0"
                step="0.01"
                class="input-field"
                placeholder="0.00"
                [ngClass]="{
                    'is-invalid': isControlInvalid('length'),
                    'is-valid':
                        !isControlInvalid('length') &&
                        partitionFormGroup.get('length').touched
                }"
            />
            <div
                class="invalid-feedback"
                *ngIf="
                    partitionFormGroup.get('length').invalid &&
                    (partitionFormGroup.get('length').touched ||
                        partitionFormGroup.get('length').dirty)
                "
            >
                <span *ngIf="partitionFormGroup.get('length').errors?.required"
                    >Length is required.</span
                >
                <span *ngIf="partitionFormGroup.get('length').errors?.min"
                    >Length must be greater than 0.</span
                >
            </div>
        </div>
    </div>

    <!-- Second Row: Sensors and Capacity -->
    <div class="partition-form-row">
        <!-- SENSORS - HIDE UI
        <div class="input-group-farm sensor-selection">
            <label for="deviceId{{ index }}">Select Sensors:</label>
            <p-multiSelect
                [options]="availableSensors"
                formControlName="sensors"
                optionLabel="name"
                optionValue="id"
                appendTo="body"
                class="custom-multiselect"
                defaultLabel="Select sensors for this partition"
                placeholder="Choose sensors..."
                [filter]="true"
                filterPlaceHolder="Search sensors..."
                [showToggleAll]="true"
                [showHeader]="true"
                [displaySelectedLabel]="true"
                [maxSelectedLabels]="3"
                selectedItemsLabel="{0} sensors selected"
            >
            </p-multiSelect>
            <div
                class="invalid-feedback"
                *ngIf="
                    partitionFormGroup.get('sensors').invalid &&
                    (partitionFormGroup.get('sensors').touched ||
                        partitionFormGroup.get('sensors').dirty)
                "
            >
                <span *ngIf="partitionFormGroup.get('sensors').errors?.required"
                    >Please select at least one sensor.</span
                >
            </div>
        </div>
        -->

        <div class="input-group-farm">
            <label for="capacity{{ index }}"
                >Capacity (per chick):<span class="text-danger-required"
                    >*</span
                ></label
            >
            <input
                id="capacity{{ index }}"
                formControlName="capacity"
                type="number"
                min="0"
                class="input-field"
                placeholder="0"
                [ngClass]="{
                    'is-invalid': isControlInvalid('capacity'),
                    'is-valid':
                        !isControlInvalid('capacity') &&
                        partitionFormGroup.get('capacity').touched
                }"
            />
            <div
                class="invalid-feedback"
                *ngIf="
                    partitionFormGroup.get('capacity').invalid &&
                    (partitionFormGroup.get('capacity').touched ||
                        partitionFormGroup.get('capacity').dirty)
                "
            >
                <span
                    *ngIf="partitionFormGroup.get('capacity').errors?.required"
                    >Capacity is required.</span
                >
                <span *ngIf="partitionFormGroup.get('capacity').errors?.min"
                    >Capacity must be greater than 0.</span
                >
            </div>
        </div>
    </div>
</div>
